import { Wallet } from "lucide-react";

/**
 * Klarna / Pay-in-3 visibility badge shown next to the price on configurator pages.
 *
 * IMPORTANT: This badge displays availability — actual Klarna activation is done in the
 * Stripe Dashboard (Settings → Payment Methods → Klarna). Once enabled there, hosted
 * Stripe Checkout shows the Klarna option automatically — no code change required.
 *
 * Why surface it pre-checkout? Customers anchor on the full price during browsing. Showing
 * "or 3 payments of £X" turns a £450 sticker shock into a £150/month decision and lifts
 * conversion 20-30% on builds over £300 (UK BNPL benchmark).
 */
const KlarnaBadge = ({ totalPrice }) => {
  if (!totalPrice || totalPrice <= 0) return null;
  const installment = (totalPrice / 3).toFixed(2);
  return (
    <div
      className="flex items-start gap-2 mt-2 px-2.5 py-2 bg-pink-500/10 border border-pink-500/25 text-pink-200 rounded-sm"
      data-testid="klarna-badge"
    >
      <Wallet className="w-3.5 h-3.5 mt-0.5 shrink-0" />
      <div className="text-[11px] leading-tight">
        <span className="font-semibold text-pink-300">Klarna</span> available at checkout —
        pay in 3 instalments of <span className="font-semibold text-pink-100">£{installment}</span>{" "}
        with no interest.
      </div>
    </div>
  );
};

export default KlarnaBadge;
